<vp-availability-widget-input
	[className]="className()"
	[disabled]="items().length === 1"
	[excludeFromClosingRegex]="excludeFromClosingRegex()"
	[header]="label()"
	[iconName]="iconName()"
	[inputName]="inputName()"
	[isOpen]="isOpen()"
	[label]="label()"
	[placeholder]="placeholder()"
	[value]="selectedItemName()"
	(emitIsOpen)="popoverStateChanged($event)"
>
	<div class="flex max-h-[246px] flex-col overflow-y-auto">
		@for (item of items(); track $index) {
			<button
				(click)="onSelectItem(item)"
				class="btn btn-text w-full justify-start text-base font-normal hover:bg-secondary-75"
				data-test-class="availability-item-selector-option"
			>
				{{ item.name }}
			</button>
		}
	</div>
</vp-availability-widget-input>
